/**
 * The types of images used by the form
 */
export const IkeCaptureType = {
	/**
	 * Generic image with no sensor data required.
	 * Similar to how a smart phone would take a image
	 * */
	IMAGE: 'image' as const,
	/**
	 * Calibrated image taken with a IKE Device
	 *
	 * This image has a lot of sensor data with it, location, IMU, GPS etc.
	 */
	TRUE_SIZE: 'truesize' as const,
};
export type IkeCaptureType = typeof IkeCaptureType.IMAGE | typeof IkeCaptureType.TRUE_SIZE;
